import { API_URL, jwtToken } from "../../../context/appContext";
export default async function calculateConversion(data) {
    return fetch(`${API_URL}/api/profile/conversion`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + jwtToken
        }, body: JSON.stringify(data)
    })
        .then(res => res.json())
        .then(res => res)
        .catch(err => err)
}
